import { baseApi } from "../baseApi";
import { buildQueryParams } from "../queryUtils";

export const batchesApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [
      "BulkClaimsBatches",
      "AuditApprovalBatches",
      "AutoCorrectionBatches",
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getBulkClaimsBatches: builder.query({
        query: (params) => ({
          url: "/v3/invoices/bulkJobs",
          method: "GET",
          params: buildQueryParams(params),
        }),
        providesTags: ["BulkClaimsBatches"],
      }),

      getAuditApprovalBatches: builder.query({
        query: (params) => ({
          url: "/v3/invoices/audit-results/bulk-jobs",
          method: "GET",
          params: buildQueryParams(params),
        }),
        providesTags: ["AuditApprovalBatches"],
      }),

      getAutoCorrectionBatches: builder.query({
        query: (params) => ({
          url: "/v3/invoices/audit/auto-correct/jobs",
          method: "GET",
          params: buildQueryParams(params),
        }),
        providesTags: ["AutoCorrectionBatches"],
      }),
    }),
  });

export const {
  useGetBulkClaimsBatchesQuery,
  useLazyGetBulkClaimsBatchesQuery,
  useGetAuditApprovalBatchesQuery,
  useLazyGetAuditApprovalBatchesQuery,
  useGetAutoCorrectionBatchesQuery,
  useLazyGetAutoCorrectionBatchesQuery,
} = batchesApi;
